import { useFormattedReference } from "@hooks/useFormattedReference";
import type { Gates } from "@services/reference-data/types";
import { REFERENCE_DATA_TYPES } from "@services/referenceDataApi";
import type { PortCode } from "@services/vessel-call/types";
import { t } from "i18next";

export type CompanyType = {
  companyNameEnglish: string;
  companyCode: string;
};

export function useVisitorDetailsReferenceData({ gatepassService }: { gatepassService: string }) {
  const { options: ports, isLoading: isLoadingPorts } = useFormattedReference<PortCode>(
    REFERENCE_DATA_TYPES.PORT_CODES,
    gatepassService,
  );
  const { options: companies } = useFormattedReference<CompanyType>(
    `${REFERENCE_DATA_TYPES.COMPANIES}?isLicensedCompany=true`,
    gatepassService,
  );
  const { options: gates, isLoading: isLoadingGates } = useFormattedReference<Gates>(
    REFERENCE_DATA_TYPES.GATES,
    gatepassService,
  );
  const fottDisplayOptions = [
    { label: t("common.yes"), value: t("yes") },
    { label: t("common.no"), value: t("no") },
  ];

  return { ports, isLoadingPorts, companies, gates, isLoadingGates, fottDisplayOptions };
}
